import * as React from 'react';
import { createSvg } from './utils/createSvg';
export var FlagCz = createSvg(React.createElement(React.Fragment, null,
    React.createElement("clipPath", { id: "FlagCz-a" },
        React.createElement("path", { d: "M102.42 0h708.66v708.66H102.42z" })),
    React.createElement("g", { clipPath: "url(#FlagCz-a)", fillRule: "evenodd", strokeWidth: "1pt", transform: "translate(-74) scale(.722)" },
        React.createElement("path", { d: "M0 0h1063v708.66H0z", fill: "#e80000" }),
        React.createElement("path", { d: "M0 0h1063v354.33H0z", fill: "#fff" }),
        React.createElement("path", { d: "M0 0l529.732 353.88L0 707.3z", fill: "#00006f" }))), '0 0 512 512', 'FlagCz');
//# sourceMappingURL=FlagCz.js.map